import { useState } from "react";
import Icon from "./Icon.jsx";
import { signIn } from "../lib/api.js";

export default function Login({ onAuth }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!email || !password) {
      setError("Enter email and password");
      return;
    }
    setLoading(true);
    setError("");
    const res = await signIn(email, password);
    if (res.access_token) {
      onAuth(res.access_token);
    } else {
      setError(res.error_description || "Sign in failed");
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 8,
    border: "1px solid var(--brd)",
    background: "var(--s2)",
    color: "var(--t1)",
    fontSize: 14,
    marginBottom: 8,
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <div
        style={{
          background: "var(--s1)",
          border: "1px solid var(--brd)",
          borderRadius: 20,
          padding: 40,
          width: 380,
          textAlign: "center",
        }}
      >
        <div style={{ marginBottom: 14 }}>
          <Icon name="bolt" size={28} color="var(--volt)" fill />
        </div>
        <h1 style={{ fontFamily: "var(--d)", fontSize: 22, fontWeight: 700, marginBottom: 6 }}>
          Volta
        </h1>
        <p style={{ fontSize: 14, color: "var(--t2)", marginBottom: 24 }}>
          Sign in to Command Center
        </p>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          style={inputStyle}
        />
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          placeholder="Password"
          onKeyDown={(e) => e.key === "Enter" && submit()}
          style={{ ...inputStyle, marginBottom: 14 }}
        />
        {error && (
          <div style={{ fontSize: 12, color: "var(--red)", marginBottom: 10 }}>{error}</div>
        )}
        <button
          onClick={submit}
          disabled={loading}
          style={{
            width: "100%",
            padding: 13,
            borderRadius: 8,
            border: "none",
            background: "var(--volt)",
            color: "#0A0A0F",
            fontSize: 15,
            fontWeight: 700,
            fontFamily: "var(--d)",
            cursor: loading ? "wait" : "pointer",
            opacity: loading ? 0.6 : 1,
          }}
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </div>
    </div>
  );
}
